export default "__VITE_ASSET__Cz7KGN4z__"